import { render, staticRenderFns } from "./I18nEditor.vue?vue&type=template&id=07a86bf7&scoped=true&"
import script from "./I18nEditor.vue?vue&type=script&lang=js&"
export * from "./I18nEditor.vue?vue&type=script&lang=js&"
import style0 from "./I18nEditor.vue?vue&type=style&index=0&id=07a86bf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a86bf7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VContainer,VIcon,VOverlay,VProgressCircular,VSimpleTable})
